/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Answer_IncorrectInputs */

const en_player_answer_incorrect = /** @type {(inputs: Player_Answer_IncorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorrect.`)
};

const ja_player_answer_incorrect = /** @type {(inputs: Player_Answer_IncorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不正解です。`)
};

const fr_player_answer_incorrect = /** @type {(inputs: Player_Answer_IncorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorrect.`)
};

const de_player_answer_incorrect = /** @type {(inputs: Player_Answer_IncorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falsch.`)
};

/**
* | output |
* | --- |
* | "Incorrect." |
*
* @param {Player_Answer_IncorrectInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const player_answer_incorrect = /** @type {((inputs?: Player_Answer_IncorrectInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Answer_IncorrectInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_player_answer_incorrect(inputs)
	if (locale === "ja") return ja_player_answer_incorrect(inputs)
	if (locale === "fr") return fr_player_answer_incorrect(inputs)
	return de_player_answer_incorrect(inputs)
});